import React from "react";
import { encodeId, slugify } from "../helper/helperFunction";
import { useTranslation } from "react-i18next";
import { useCountryPrefix } from "../routes/useCountryPrefix";
import CustomImageComponent from "./CustomImageComponent";

const NewLaunch = (props) => {
  const countryPrefix = useCountryPrefix();

  const { i18n } = useTranslation();

  const { data } = props;
  const isArabic = i18n.language === "ar";
  const currentLang = isArabic ? "/ar" : "";

  return (
    <>
      {data && (
        <section
          className="launches-section"
          data-aos="fade-up"
          data-aos-duration="1500"
        >
          <div className="container">
            <h5 className="sub-title text-center">{data?.sectionTitle}</h5>
            <h2 className="title text-center">{data?.sectionHeader}</h2>
          </div>
          <div className="marquee">
            {data?.sectionItems?.length &&
              data?.sectionItems?.map((item, index) => (

                <a href={`/${countryPrefix}${currentLang ? `/${currentLang}` : ""}/launch/${slugify(item.projectName)}/${encodeId(item.projectId)}`} key={index}>
                  <CustomImageComponent
                    alt={item.title}
                    loading={"eager"}
                    decoding={"async"}
                    datanimg={"1"}
                    className={"img-fluid"}
                    src={item.image}
                  />
                </a>


              ))}
          </div>
          {/* <!-- Marquee moving right to left --> */}
          <div className="marquee reverse">
            {data?.sectionItems?.length &&
              data?.sectionItems?.map((item, index) => (
                <a href={`/${countryPrefix}${currentLang ? `/${currentLang}` : ""}/launch/${slugify(item.projectName)}/${encodeId(item.projectId)}`} key={index}>
                  <CustomImageComponent
                    alt={item.title}
                    loading={"eager"}
                    decoding={"async"}
                    datanimg={"1"}
                    className={"img-fluid"}
                    src={item.image}
                  />
                </a>
              ))}
          </div>
        </section>
      )}
    </>
  );
};

export default NewLaunch;
